module.exports = __webpack_public_path__ + "static/img/ticket.2ad2762.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ticket.svg
// module id = 7eX1
// module chunks = 2